import TopicsPage from "@/pages/_topics";
import { useIntl } from "react-intl";
import ErrorPage from "@/pages/_error";
import ForumHelmet from "@/components/ForumHelmet";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { DatasetTopicsPageQuery as DatasetTopicsPageQueryType } from "./__generated__/DatasetTopicsPageQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
import { getVotableOrderParam } from "@/utils/votableOrder";
export default function DatasetTopicsPage() {
  const {
    query,
    variables: { order: initialOrder },
  } = useDatasetTopicsPageQuery();
  const forum = query?.datasetBySlug?.forum;
  const intl = useIntl();
  if (!forum) {
    return (
      <ErrorPage
        status={404}
        message={intl.formatMessage({ defaultMessage: "Dataset not found" })}
      />
    );
  }
  return (
    <ForumHelmet forum={forum}>
      <TopicsPage forum={forum} initialOrder={initialOrder} />
    </ForumHelmet>
  );
}
const DatasetTopicsPageQuery = graphql`
  query DatasetTopicsPageQuery(
    $owner: String!
    $slug: String!
    $order: VotableOrder!
  ) {
    datasetBySlug(owner: $owner, localSlug: $slug) {
      forum {
        ...TopicsPageFragment @arguments(order: $order)
        ...ForumHelmetFragment
      }
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { owner, slug }, request }: LoaderArgs) => {
    const order = getVotableOrderParam(request) || "NEWEST";
    if (!owner || !slug) {
      throw new Response("No owner or slug", { status: 500 });
    }
    return preload<DatasetTopicsPageQueryType>(
      environment,
      DatasetTopicsPageQuery,
      {
        owner,
        slug,
        order,
      },
    );
  };
};
const useDatasetTopicsPageQuery = () =>
  usePreloaded<DatasetTopicsPageQueryType>();
